import { Box, Flex, Spacer, Stack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';
import { useTimer } from 'react-timer-hook';

interface TimerCountdownProps {
    expiryTimestamp: any,
    countdownFontSize?: any,
    textFontSize?: any,
    includeDays: boolean
}

const TimerCountdown: FC<TimerCountdownProps> = ({ expiryTimestamp, countdownFontSize, textFontSize, includeDays }) => {
    const {
        seconds,
        minutes,
        hours,
        days

    } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });

    return (
        <Flex textAlign={"center"}>
            <Spacer />
            <Flex fontSize={countdownFontSize || '5xl'}>
                {
                    includeDays &&
                    <>
                        <Box>
                            <Text fontWeight={"bold"}>{days}</Text>
                            <Text fontSize={textFontSize || 'xl'} mt={-2}>Hari</Text>
                        </Box>
                        <Box ml={2}>
                            <Text fontWeight={"bold"}>:</Text>
                        </Box>
                    </>
                }

                <Box ml={2}>
                    <Text fontWeight={"bold"}>{hours}</Text>
                    <Text fontSize={textFontSize || 'xl'} mt={-2}>Jam</Text>
                </Box>
                <Box ml={2}>
                    <Text fontWeight={"bold"}>:</Text>
                </Box>
                <Box ml={2}>
                    <Text fontWeight={"bold"}>{minutes}</Text>
                    <Text fontSize={textFontSize || 'xl'} mt={-2}>Menit</Text>
                </Box>
                <Box ml={2}>
                    <Text fontWeight={"bold"}>:</Text>
                </Box>
                <Box ml={2}>
                    <Text fontWeight={"bold"}>{seconds}</Text>
                    <Text fontSize={textFontSize || 'xl'} mt={-2}>Detik</Text>
                </Box>
            </Flex>
            <Spacer />
        </Flex>
        //<div style={{ textAlign: 'center' }}>
        //    <div style={{ fontSize: '50px' }}>
        //        <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>
        //    </div>
        //</div>
    );
};

export default TimerCountdown;